export var BlockchainType;
(function (BlockchainType) {
    BlockchainType["SOLANA"] = "SOLANA";
    BlockchainType["APTOS"] = "APTOS";
    BlockchainType["EVM"] = "EVM";
})(BlockchainType || (BlockchainType = {}));
export class DappNotificationSubscription {
}
//# sourceMappingURL=dapp.interface.js.map